'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/8/3.
                                   */

// import {PersonalCenterTopBar} from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyExperienceShop = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyExperienceShop, _Component);

  function MyExperienceShop() {
    (0, _classCallCheck3.default)(this, MyExperienceShop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MyExperienceShop).call(this));

    _this.state = {
      hoverIndex: -1
    };
    return _this;
  }

  (0, _createClass3.default)(MyExperienceShop, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props;
      var user = _props.user;
      var dispatch = _props.dispatch;

      if (user && !nextProps.user) {
        dispatch((0, _reactRouterRedux.push)('/login'));
      }
    }
  }, {
    key: 'onQuit',
    value: function onQuit() {
      var dispatch = this.props.dispatch;

      if (dispatch) {
        dispatch((0, _auth.logout)());
      }
    }
  }, {
    key: 'onLiMouseAction',
    value: function onLiMouseAction(index) {
      this.setState({
        hoverIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./MyExperienceShop.scss');
      var user = this.props.user;
      var hoverIndex = this.state.hoverIndex;

      var result = _react2.default.createElement('div', null);
      var menuArray = [{
        text: '体验店信息',
        url: '/experienceshop/experienceshopinfo',
        activeUrl: '/experienceshop/experienceshopinfo'
      }, {
        text: '体验店购买',
        url: '/experienceshop/experienceshopselling',
        activeUrl: '/experienceshop/experienceshopselling'
      }, {
        text: '体验店艺品',
        url: '/experienceshop/experienceshopproducts',
        activeUrl: '/experienceshop/experienceshopproducts'
      }, {
        text: '体验店会员',
        url: '/experienceshop/experienceshopmembers',
        activeUrl: '/experienceshop/experienceshopmembers'
      }, {
        text: '体验店活动',
        url: '/experienceshop/experienceshoppromotion',
        activeUrl: '/experienceshop/experienceshoppromotion'
      }, {
        text: '店主提成',
        url: '/experienceshop/experienceshopcommission',
        activeUrl: '/experienceshop/experienceshopcommission'
      }];
      if (user) {
        result = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.leftBar },
            _react2.default.createElement(
              'div',
              { className: styles.personalInfo },
              _react2.default.createElement(
                'div',
                { className: styles.headerImg },
                _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/toubg.jpg', alt: '' })
              ),
              _react2.default.createElement(
                'h1',
                null,
                '绿松石体验店'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '您好，',
                _react2.default.createElement('br', null),
                '欢迎来到 ',
                _react2.default.createElement(
                  'span',
                  { className: styles.red },
                  '艺品网'
                )
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.menu },
              menuArray.map(function (item, index) {
                var currentClassName = styles['back' + (index + 1)];
                if (item.activeUrl && item.activeUrl !== '' && location.pathname.indexOf(item.activeUrl) > -1) {
                  currentClassName = currentClassName + ' ' + styles.active;
                } else if (hoverIndex === index) {
                  currentClassName = currentClassName + ' ' + styles.active;
                }
                return _react2.default.createElement(
                  'li',
                  { key: index, className: currentClassName, onMouseOut: function onMouseOut() {
                      return _this2.onLiMouseAction(-1);
                    },
                    onMouseOver: function onMouseOver() {
                      return _this2.onLiMouseAction(index);
                    } },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: item.url },
                    _react2.default.createElement('i', {
                      className: styles['ic' + (index + 1)] }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.text
                    )
                  )
                );
              })
            ),
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/dianbg7.jpg', alt: '' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.rightContent },
            _react2.default.createElement('div', { className: styles.carousel }),
            _react2.default.createElement('div', { className: 'clear' }),
            this.props.children
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      return result;
    }
  }]);
  return MyExperienceShop;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object,
  user: _react.PropTypes.object,
  dispatch: _react.PropTypes.func
}, _temp)) || _class);
exports.default = MyExperienceShop;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyExperienceShop/MyExperienceShop.js
 ** module id = 1499
 ** module chunks = 0
 **/